import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core'
import {FormGroup} from '@angular/forms'

@Component({
  selector: 'dmmp-form-button',
  templateUrl: './button.component.html',
})
export class ButtonComponent implements OnInit {
  @Input() field
  @Input() identifier
  @Input() loading
  @Input() form
  @Input() group: FormGroup
  @Output() submitValidation: EventEmitter<any> = new EventEmitter<any>()
  constructor() {
  }

  ngOnInit() {
  }
}
